import { api } from "./api";

export const examQuestionSkillQuestionService = {
    async createExamQuestionSkillQuestion(examQuestionSkillId: any, questionId: any, no: number): Promise<any> {
        const response = await api.post('exam-question-skill-questions', {
            examQuestionSkillId,
            questionId,
            no
        });
        return response.data;
    },

    async findExamQuestionSkillQuestionsByExamQuestionSkillIdAndNo(
        examQuestionSkillId: string, no: number
    ): Promise<any> {
        const response = await api.get(`exam-question-skill-questions/by-exam-question-skill-id-and-no/${examQuestionSkillId}/${no}`);
        return response.data;
    },

    async updateExamQuestionSkillQuestion(examQuestionSkillQuestion: any): Promise<any> {
        console.log({ examQuestionSkillQuestion });
        
        const response = await api.put(`exam-question-skill-questions/${examQuestionSkillQuestion.id}`, examQuestionSkillQuestion);
        return response.data;
    }
};